import { useCallback, useEffect } from "react";

import { isEditableElement } from "@/utils/dom";

/**
 * Captures the \ key to toggle the Activity panel.
 * Mirrors the pattern of useSidebarToggleShortcut ([).
 */
export const useActivityPanelToggleShortcut = (onToggle: () => void, enabled: boolean) => {
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (!enabled) return;

            if (event.key !== "\\") return;

            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

            if (isEditableElement(event.target)) return;

            if (event.defaultPrevented) return;

            event.preventDefault();
            onToggle();
        },
        [onToggle, enabled],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [handleKeyDown]);
};
